import(/* webpackMode: "eager", webpackExports: ["RouteRestrictionGuard"] */ "/vercel/path0/apps/web/components/auth/RouteRestrictionGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/features/shell/Shell.tsx");
